<template>
    <div>
        <h5 class="mb-1 mt-3">{{ $t("New to crypto? You're in good hands") }}</h5>
        <p class="text-secondary small mb-4">
            {{ $t("It takes a couple of minutes, and it's the most private way to pay.") }}
        </p>

        <!-- Why guys pay this way — lead with the value, not the tech -->
        <div class="d-flex align-items-start mb-3">
            <font-awesome-icon
                icon="fa-duotone fa-user-secret"
                class="text-primary mr-3 mt-1"
                size="lg"
            />
            <div>
                <h6 class="mb-0">{{ $t("Nothing shows on your statement") }}</h6>
                <div class="small text-secondary">
                    {{
                        $t(
                            "Your bank and card statements won't show anything recognizable. What you spend it on stays your business."
                        )
                    }}
                </div>
            </div>
        </div>

        <div class="d-flex align-items-start mb-3">
            <font-awesome-icon
                icon="fa-duotone fa-shield-check"
                class="text-primary mr-3 mt-1"
                size="lg"
            />
            <div>
                <h6 class="mb-0">{{ $t("Private & discreet") }}</h6>
                <div class="small text-secondary">
                    {{
                        $t(
                            "No name attached, no paper trail. Total discretion, start to finish."
                        )
                    }}
                </div>
            </div>
        </div>

        <div class="d-flex align-items-start mb-4">
            <font-awesome-icon
                icon="fa-duotone fa-lock"
                class="text-primary mr-3 mt-1"
                size="lg"
            />
            <div>
                <h6 class="mb-0">{{ $t("Safe and secure") }}</h6>
                <div class="small text-secondary">
                    {{
                        $t(
                            "A trusted processor handles everything. Your credits are added the moment it clears."
                        )
                    }}
                </div>
            </div>
        </div>

        <!-- Dead-simple how-to -->
        <h6 class="mb-2">{{ $t("All you do:") }}</h6>

        <div class="d-flex align-items-center mb-2">
            <div class="circle-list mr-2">1</div>
            <div>{{ $t("We send you to our secure payment page.") }}</div>
        </div>
        <div class="d-flex align-items-center mb-2">
            <div class="circle-list mr-2">2</div>
            <div>
                {{
                    $t(
                        "Pick a coin like Bitcoin. It shows you the exact amount and where to send it."
                    )
                }}
            </div>
        </div>
        <div class="d-flex align-items-center mb-2">
            <div class="circle-list mr-2">3</div>
            <div>
                {{
                    $t(
                        "Send it from your crypto app and sit back — your credits land automatically."
                    )
                }}
            </div>
        </div>

        <p class="text-secondary small mt-3 mb-0">
            {{
                $t(
                    "First time? You can pick up a little Bitcoin in minutes with an app like Coinbase or Cash App, then send it here."
                )
            }}
        </p>
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
/* Keep the numbered badges perfectly round — without this they get squeezed into
   ovals in the flex row whenever the step text wraps to a second line. */
.circle-list {
    flex-shrink: 0;
}
</style>
